export default __webpack_public_path__ + "static/media/plain-sticker-I.920e3564.png";